module.exports = ".suphead\r\n{\r\n    background-color: rgb(100,100,100);\r\n    color:white;\r\n    margin-top:10px;\r\n}"